import {
    FormAnswerSelectedOption,
    FormElementFile,
    FormElementGridCellAnswer,
    SelectedOption,
    WorksheetElementAnswers,
    WorksheetGridCellAnswer,
} from '@packages/models/api';

interface Props {
    handleAnswerChange?: (formelementId: string, selectedAnswer: FormAnswerSelectedOption[]) => void;
    handleGridCellAnswerChange?: (formElementId: string, gridCellAnswer: FormElementGridCellAnswer[]) => void;
    onAnswerChange?: (answer: WorksheetElementAnswers) => void;
}

export const useAnswerHandle = ({ handleAnswerChange, handleGridCellAnswerChange, onAnswerChange }: Props) => {
    const handleAnswer = (formElementId: string, answer: SelectedOption[], asset?: FormElementFile) => {
        handleAnswerChange?.(formElementId, answer);
        onAnswerChange?.({
            elementId: formElementId,
            selectedOptions: answer,
            asset: asset ? { answerFile: { ...asset } } : undefined,
        });
    };

    const handleGridAnswer = (formElementId: string, gridCellAnswers: WorksheetGridCellAnswer[]) => {
        handleGridCellAnswerChange?.(formElementId, gridCellAnswers);
        onAnswerChange?.({
            elementId: formElementId,
            selectedOptions: [],
            worksheetGridCellAnswers: gridCellAnswers,
        });
    };

    return {
        handleAnswer,
        handleGridAnswer,
    };
};
